import { VideoCard } from './VideoCard'

interface Video {
  id: string
  title: string
  thumbnail: string
  channel_title: string
  channel_id: string
  published_at: string
  duration: string
  description?: string
}

interface VideoGridProps {
  videos: Video[]
}

export function VideoGrid({ videos }: VideoGridProps) {
  if (videos.length === 0) {
    return null
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
      {videos.map((video) => (
        <VideoCard key={video.id} video={video} />
      ))}
    </div>
  )
}